export default {
    ALL: "Все",
    SEARCH_INPUT_PLACEHOLDER: "Поиск...",
    MODAL_OK: "Подтвердить",
    MODAL_CANCEL: "Отмена",
    APPLY: "Применить"
};
